import { LocationTabWrapper, LocationTabItem } from './LocationTab.styled'
import { useState, useEffect } from 'react'
import { LAYOUT_TEMPLATE } from '../../services/api/types'
import { useRouter } from 'next/router'

export interface LocationTabProps {
  tabItems?: Array<string>
  selectedTab?: string
  tabClick?: Function
  template?: LAYOUT_TEMPLATE
}

export const LocationTab = (props: LocationTabProps) => {
  const { tabItems, tabClick, selectedTab, template } = props
  const [selectTab, setSelectTab] = useState(selectedTab)
  const router = useRouter()

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash && tabItems && tabItems.length > 0) {
      const matchedTab = tabItems.find(
        tab => tab.replace(/\s+/g, '-').toLowerCase() === hash.toLowerCase()
      )
      if (matchedTab) {
        setSelectTab(matchedTab)
        setTimeout(() => {
          tabClick && tabClick(matchedTab)
        }, 100)
      }
    }
  }, [])

  const onTabClick = (tabName: string) => {
    const path = router.asPath.split('#')[0]

    if (tabName) {
      const formattedTabName = tabName.replace(/\s+/g, '-').toLowerCase()
      const newUrl = `${path}#${formattedTabName}`
      window.history.replaceState(null, '', newUrl)
    } else {
      window.history.replaceState(null, '', path)
    }

    tabClick && tabClick(tabName)
    setSelectTab(tabName)
  }

  return (
    <LocationTabWrapper template={template}>
      <LocationTabItem
        dangerouslySetInnerHTML={{ __html: 'ALL' }}
        className={selectTab === '' ? 'active' : ''}
        onClick={() => onTabClick('')}
      />
      {tabItems &&
        tabItems.length > 0 &&
        !(tabItems.length === 1 && tabItems[0] === '') &&
        tabItems.map((tab: string, idx) => {
          return (
            <LocationTabItem
              key={idx}
              className={
                tab?.toLowerCase() === selectTab?.toLowerCase() ? 'active' : ''
              }
              onClick={() => onTabClick(tab)}
            >
              {tab}
            </LocationTabItem>
          )
        })}
    </LocationTabWrapper>
  )
}

export default LocationTab
